import React from 'react';
import { Card } from '../../../components/ui/Card';
import { TabNavigation } from '../../../components/operations/TabNavigation';
import { OperationsSwitcher } from '../../../components/operations/OperationsSwitcher';
import { Plus, Users, Clock, Activity } from 'lucide-react';
const LOCATION_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Capacity',
  path: 'capacity'
}, {
  label: 'Performance',
  path: 'performance'
}, {
  label: 'Costs',
  path: 'costs'
}, {
  label: 'Settings',
  path: 'settings'
}];
const STATIONS = [{
  name: 'BURGERI',
  icon: '🍔',
  capacity: 25,
  staff: 2,
  prep: '8 min',
  active: true
}, {
  name: 'PALAČINKE',
  icon: '🥞',
  capacity: 20,
  staff: 1,
  prep: '6 min',
  active: true
}, {
  name: 'PAKOVANJE',
  icon: '📦',
  capacity: 50,
  staff: 1,
  prep: '2 min',
  active: true
}, {
  name: 'SALATE',
  icon: '🥗',
  capacity: 15,
  staff: 1,
  prep: '5 min',
  active: false
}, {
  name: 'GIROS',
  icon: '🌯',
  capacity: 12,
  staff: 1,
  prep: '7 min',
  active: true
}];
export function Capacity() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1690">
      <h1 className="text-2xl font-bold text-text-primary" data-id="element-1691">Kitchen Capacity</h1>

      <OperationsSwitcher data-id="element-1692" />

      <TabNavigation tabs={LOCATION_TABS} basePath="/operations/locations" data-id="element-1693" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1694">
        {STATIONS.map(station => <Card key={station.name} className={`relative ${!station.active ? 'opacity-60' : ''}`} data-id="element-1695">
            <div className="flex justify-between items-start mb-4" data-id="element-1696">
              <div className="flex items-center gap-2" data-id="element-1697">
                <span className="text-2xl" data-id="element-1698">{station.icon}</span>
                <h3 className="font-bold" data-id="element-1699">{station.name}</h3>
              </div>
              <div className={`w-3 h-3 rounded-full ${station.active ? 'bg-accent-success' : 'border border-text-secondary'}`} data-id="element-1700"></div>
            </div>

            <div className="space-y-4" data-id="element-1701">
              <div className="flex justify-between items-center p-3 bg-background-elevated rounded-lg" data-id="element-1702">
                <span className="text-sm text-text-secondary" data-id="element-1703">Capacity</span>
                <span className="font-bold" data-id="element-1704">{station.capacity} orders/hr</span>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-1705">
                <div className="flex items-center gap-2 text-sm" data-id="element-1706">
                  <Users size={16} className="text-text-secondary" data-id="element-1707" />
                  <span data-id="element-1708">Staff: {station.staff}</span>
                </div>
                <div className="flex items-center gap-2 text-sm" data-id="element-1709">
                  <Clock size={16} className="text-text-secondary" data-id="element-1710" />
                  <span data-id="element-1711">Prep: {station.prep}</span>
                </div>
              </div>
            </div>
          </Card>)}

        <button className="border-2 border-dashed border-white/10 rounded-xl flex flex-col items-center justify-center text-text-secondary hover:text-text-primary hover:border-white/20 transition-all min-h-[200px]" data-id="element-1712">
          <Plus size={32} className="mb-2" data-id="element-1713" />
          <span className="font-medium" data-id="element-1714">Add Station</span>
        </button>
      </div>

      <Card className="mt-8 bg-background-elevated/50" data-id="element-1715">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-1716">
          <div data-id="element-1717">
            <div className="text-xs text-text-secondary uppercase font-bold mb-1" data-id="element-1718">
              Max Output
            </div>
            <div className="text-2xl font-bold" data-id="element-1719">45 orders/hr</div>
          </div>
          <div data-id="element-1720">
            <div className="text-xs text-text-secondary uppercase font-bold mb-1" data-id="element-1721">
              Bottleneck
            </div>
            <div className="text-2xl font-bold text-accent-warning" data-id="element-1722">
              Giros (12/hr)
            </div>
          </div>
          <div data-id="element-1723">
            <div className="text-xs text-text-secondary uppercase font-bold mb-1" data-id="element-1724">
              Staff Required
            </div>
            <div className="text-2xl font-bold" data-id="element-1725">6</div>
          </div>
          <div data-id="element-1726">
            <div className="text-xs text-text-secondary uppercase font-bold mb-1" data-id="element-1727">
              Avg Prep Time
            </div>
            <div className="text-2xl font-bold" data-id="element-1728">6.5 min</div>
          </div>
        </div>
      </Card>
    </div>;
}